import vuexStore from '../../core/vuexStore'

export const { state, getters, mutations, actions, namespaced } = vuexStore({
    routes: {
        getWidgetActions: {
            isLoading: true,
            isUpdateWithReplace: true,
            endpoint: '/widget-types/{widgetTypeId}/widget-actions'
        }
    }
})
